<template lang="html">
<div>
    <div class="inner-page">
          <Header headtype="black">
                <div class="head-content">北京典籍与经典老唱片数字化出版项目</div>
          </Header>
          <div class="scroll-list" :style="'height:' + scrollH + 'px'">
                <div class="panels">
                      <img :src="panelUrl" alt="">
                </div>
                <div class="project-text">
                    {{pText}}
                </div>
                <pBlock :dataArr="datArr6" :compx="6" />
                <pBlock :dataArr="datArr5" :compx="5" />
                <pBlock :dataArr="datArr4" :compx="4" />
              <!-- 第一部分 -->
                <pBlock :dataArr="datArr3" :compx="3" />
                <!-- 第一部分 -->
                <pBlock :dataArr="datArr1" :compx="1" />

                <!-- 第二部分 -->
                <pBlock :dataArr="datArr2" :compx="2" />

          </div>
    </div>
</div>
</template>

<script>
import Data from "./data/project";
import pBlock from "./src/pBlock";
export default {
    components:{
        pBlock
    },
    data(){
        return{
            panelUrl:Data.panel,
            pText:Data.pjText,
            datArr3:[],
            datArr1:[],
            datArr2:[],
            datArr4:[],
            datArr5:[],
            datArr6:[],
            scrollH:''
        }
    },
    methods:{
        arrFmt:function(arr){
            let subArr = [];
            let tempArr = [];
            for(let i = 0;i < arr.length;i++){
                let album = {
                    id:arr[i].id,
                    img:'http://image.china1896.com/' + arr[i].img + '?imageView2/2/w/109/h/109',
                    name:arr[i].name,
                    year:arr[i].year,
                };
                subArr.push(album);
                if((i + 1)%3 == 0){
                    tempArr.push(subArr);
                    subArr = [];
                }else if((i + 1) == arr.length){
                    tempArr.push(subArr);
                }
            }
            return tempArr;
        }
    },
    mounted:function(){
        this.datArr1 = this.arrFmt(Data.albumArr1);
        this.datArr2 = this.arrFmt(Data.albumArr2);
        this.datArr3 = this.arrFmt(Data.albumArr3);
        this.datArr4 = this.arrFmt(Data.albumArr4);
        this.datArr5 = this.arrFmt(Data.albumArr5);
        this.datArr6 = this.arrFmt(Data.albumArr6);
        this.scrollH = document.documentElement.clientHeight - 105;
    }
}
</script>

<style lang="css" scoped>

.scroll-list{
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
}

.inner-page{
    padding-bottom: 60px;
    overflow-x: hidden;
}

.head-content{
    font-size: 15px;
}

.panels img{
    width: 100%;
}

.project-text{
   padding: 12px;
   font-size: 14px;
}

</style>
